import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailLabel} from '../mapping-classes/detail-label';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {ButtonData} from '../mapping-classes/button-data';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';

export class Financiallease implements DetailScreen {
  restrictedData: boolean;
  actualityDateTime: string;
  title: string;
  buttons: ButtonData[];
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;
  showDepositFlag: number;

  constructor(response: any) {
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.loanArrangementProductCategoryCode;
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.buttons = [];
      this.addButtons(response);
    }
    if (response.listOfError && response.listOfError.length !== 0) {
      this.createErrorMessage(response);
    } else {
      this.restrictedData = response.detailsViewObject.restrictedData;
      this.showDepositFlag = response.detailsViewObject.loanArrangementDepositFlag;
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  addButtons(response) {
    this.buttons.push(new ButtonData('productservicesurl', response.detailsViewObject.arrangementNumber,
      response.detailsViewObject.administrationCode, response.detailsViewObject.commercialProductTypeCode));
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Lease objecten'));
  }

  setNameAndValues() {
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.fillProductDetailsPanel(productDetailsPanel);

    const productAgreementsPanel: DetailPanel = this.panels[1];
    this.fillProductAgreementsPanel(productAgreementsPanel);
  }

  addValues(response) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);
    const productAgreementsPanel: DetailPanel = this.panels[1];
    this.addValuesToProductAgreementsPanel(productAgreementsPanel, obj);
    const leaseObjectsPanel: DetailPanel = this.panels[2];
    this.addValuesToLeaseObjectsPanel(leaseObjectsPanel, obj);
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('loanArrangementNumber', new DetailLabel('Contractnummer'));
    productDetailsPanel.nameAndValues.set('loanArrangementProductTypeCode', new DetailLabel('Naam product'));
    productDetailsPanel.nameAndValues.set('loanArrangementStatusDescription', new DetailLabel('Status'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('loanArrangementNumber').setValue(obj.loanArrangementNumber);
    productDetailsPanel.nameAndValues.get('loanArrangementProductTypeCode').setValue(obj.loanArrangementProductTypeCode);
    productDetailsPanel.nameAndValues.get('loanArrangementStatusDescription').setValue(obj.loanArrangementStatusDescription);
  }

  private fillProductAgreementsPanel(productAgreementsPanel: DetailPanel) {
    productAgreementsPanel.nameAndValues.set('loanArrangementOriginalCapitalAmount', new DetailLabel('Hoofdsom'));
    productAgreementsPanel.nameAndValues.set('loanArrangementNominalInterestRatePercentage', new DetailLabel('Rentepercentage'));
    productAgreementsPanel.nameAndValues.set('loanArrangementActivationDate', new DetailLabel('Ingangsdatum'));
    productAgreementsPanel.nameAndValues.set('loanArrangementEndResidualCapitalAmount', new DetailLabel('Restwaarde'));
    productAgreementsPanel.nameAndValues.set('loanArrangementRepaymentTotalAmount', new DetailLabel('Achterstand'));
    productAgreementsPanel.nameAndValues.set('loanArrangementPlannedEndDate', new DetailLabel('Einddatum'));
    productAgreementsPanel.nameAndValues.set('loanArrangementPaymentTermNumberOfMonths', new DetailLabel('Betaaltermijn'));
    productAgreementsPanel.nameAndValues.set('loanArrangementAnnuityTermAmount', new DetailLabel('Termijnbedrag'));
    productAgreementsPanel.nameAndValues.set('loanAccountPaymentPlanItemDueDate', new DetailLabel('Laatste betalingsdatum'));
    productAgreementsPanel.nameAndValues.set('loanAccountEffectiveRemainingCapitalAmount', new DetailLabel('Netto restant schuld'));
    if (this.showDepositFlag === 1) {
      productAgreementsPanel.nameAndValues.set('loanAccountRemainingDisbursementAmount', new DetailLabel('Restant depot'));
    }
  }

  private addValuesToProductAgreementsPanel(productAgreementsPanel: DetailPanel, obj) {
    if (!this.restrictedData) {
      productAgreementsPanel.nameAndValues.get('loanArrangementOriginalCapitalAmount').setValue(obj.loanArrangementOriginalCapitalAmount);
      productAgreementsPanel.nameAndValues.get('loanArrangementOriginalCapitalAmount').setType('amount');
      productAgreementsPanel.nameAndValues.get('loanArrangementEndResidualCapitalAmount')
        .setValue(obj.loanArrangementEndResidualCapitalAmount);
      productAgreementsPanel.nameAndValues.get('loanArrangementEndResidualCapitalAmount').setType('amount');
      productAgreementsPanel.nameAndValues.get('loanArrangementRepaymentTotalAmount').setValue(obj.loanArrangementRepaymentTotalAmount);
      productAgreementsPanel.nameAndValues.get('loanArrangementRepaymentTotalAmount').setType('amount');
      productAgreementsPanel.nameAndValues.get('loanArrangementAnnuityTermAmount').setValue(obj.loanArrangementAnnuityTermAmount);
      productAgreementsPanel.nameAndValues.get('loanArrangementAnnuityTermAmount').setType('amount');
      productAgreementsPanel.nameAndValues.get('loanAccountEffectiveRemainingCapitalAmount')
        .setValue(obj.loanAccountEffectiveRemainingCapitalAmount);
      productAgreementsPanel.nameAndValues.get('loanAccountEffectiveRemainingCapitalAmount').setType('amount');
      if (this.showDepositFlag === 1) {
        productAgreementsPanel.nameAndValues.get('loanAccountRemainingDisbursementAmount').setValue(obj.loanArrangementRemainingDisbursementAmount);
        productAgreementsPanel.nameAndValues.get('loanAccountRemainingDisbursementAmount').setType('amount');
      }
    } else {
      productAgreementsPanel.nameAndValues.get('loanArrangementOriginalCapitalAmount').setValue(this.shieldedText);
      productAgreementsPanel.nameAndValues.get('loanArrangementEndResidualCapitalAmount').setValue(this.shieldedText);
      productAgreementsPanel.nameAndValues.get('loanArrangementRepaymentTotalAmount').setValue(this.shieldedText);
      productAgreementsPanel.nameAndValues.get('loanArrangementAnnuityTermAmount').setValue(this.shieldedText);
      productAgreementsPanel.nameAndValues.get('loanAccountEffectiveRemainingCapitalAmount').setValue(this.shieldedText);
      if (this.showDepositFlag === 1) {
        productAgreementsPanel.nameAndValues.get('loanAccountRemainingDisbursementAmount').setValue(this.shieldedText);
      }
    }
    productAgreementsPanel.nameAndValues.get('loanArrangementNominalInterestRatePercentage')
      .setValue(obj.loanArrangementNominalInterestRatePercentage);
    productAgreementsPanel.nameAndValues.get('loanArrangementNominalInterestRatePercentage').setType('percentage');
    productAgreementsPanel.nameAndValues.get('loanArrangementActivationDate').setValue(obj.loanArrangementActivationDate);
    productAgreementsPanel.nameAndValues.get('loanArrangementPlannedEndDate').setValue(obj.loanArrangementPlannedEndDate);
    productAgreementsPanel.nameAndValues.get('loanArrangementPaymentTermNumberOfMonths')
      .setValue(obj.loanArrangementPaymentTermNumberOfMonths);
    productAgreementsPanel.nameAndValues.get('loanAccountPaymentPlanItemDueDate').setValue(obj.loanAccountPaymentPlanItemDueDate);
  }

  private addValuesToLeaseObjectsPanel(leaseObjectsPanel: DetailPanel, obj) {
    leaseObjectsPanel.hasTable = true;

    leaseObjectsPanel.lazyLoadingData = new LazyLoadingData(null, null, 'leaseobjects');
    leaseObjectsPanel.lazyLoadingData.data = obj.leaseObjects || [];
  }

}
